<template>
    <div class="collectioncell fr" @click="go(`/home/infodetail?id=${info.information_id}`)">
        <div class="left">
            <p class="bold">{{info.information_title}}</p>
            <p class="ellipsis-2line fz12 grey mt20">{{info.information_desc}}</p>
            <div class="fr ac jsb mt20">
                <div class="fr ac">
                    <p>文章来源:{{info.member_nick_name}}</p>
                    <p class="ml20">发布时间:{{info.update_time}}</p>
                </div>
                <p class="fr ac cursor" @click="insertCollection">
                    <i class="el-icon-star-on blue fz16"></i>
                    收藏({{info.collection_count}})
                </p>
            </div>
        </div>
        <img class="right" :src="info.information_img" alt/>
    </div>
</template>

<script>
export default {
    props: {
        info: Object,
        loading: Boolean
    },
    data() {
        return {};
    },
    computed: {},
    created() {},
    mounted() {},
    watch: {},
    methods: {
        insertCollection() {
            this.$emit("insertCollection", {
                collection_id: this.info.information_id,
                collection_type: 2
            });
        }
    },
    components: {}
};
</script>

<style scoped lang="scss">
.collectioncell {
    font-size: 14px;
    width: 100%;
    border-bottom: 1px solid #e5e5e5;
    padding: 20px 0;
    .left {
        width: calc(100% - 120px);
    }
    .right {
        width: 100px;
        height: 100px;
        flex-shrink: 0;
        margin-left: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/me/Collection/CollectionCell.vue